import { Directionality } from '@angular/cdk/bidi';
import { CdkStepper } from '@angular/cdk/stepper';
import { ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { MatStepperIntl } from '@angular/material/stepper';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'vfs-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: CdkStepper,
      useExisting: StepperComponent
    }
  ]
})
export class StepperComponent extends CdkStepper {
  isLinear = true;

  constructor(
    dir: Directionality,
    changeDetectorRef: ChangeDetectorRef,
    private stepperService: MatStepperIntl,
    private translateService: TranslateService
  ) {
    super(dir, changeDetectorRef);
    stepperService.optionalLabel = this.translateService.instant('core.general.optional');
  }

  onClick(index: number): void {
    this.selectedIndex = index;
  }
}
